import React, { useEffect, useState } from "react"
import axios from "axios"
import { SERVER_URL } from "../../databucket"
import { CustomGridTable } from "../../blueplanitUtils/CustomGridTable"
import { useDispatch } from "react-redux"
import { setLoader } from "../../Slices/loaderSlice"
import dayjs from "dayjs"

const Emails = () => {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchEmails = async () => {
            try {
                dispatch(setLoader(true))
                const response = await axios.get(`${SERVER_URL}/api/emails`)
                setData(response.data)
            }
            catch (error) {
                console.error('Error fetching emails:', error);
            }
            finally {
                dispatch(setLoader(false))
            }
        }

        fetchEmails()

    }, [])

    const columns = [
        {
            title: "Email",
            dataIndex: "email",
            Key: "email"
        },
        {
            title: "Agency Name",
            dataIndex: "agencyName",
            Key: "agencyName"
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (value) => dayjs(value).format("DD-MM-YYYY hh:mm:ss A"),
        }
    ]
    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="table-responsive">
                            <CustomGridTable
                                Id="email-table"
                                columns={columns}
                                dataSource={data}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Emails